import { DataTestGitModel } from '@y42/data-test';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath } from '@y42/feature/git';
import { AbstractGitService, FilesDef, GitParentFolders } from '@y42/feature/git/state';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { DatasourceLike } from '../datasource/datasource.model';
import { DatasourceTableSettingsGitModel } from './datasource-table-settings.model';
import { DatasourceTableStoreModel } from './datasource-table.model';

export abstract class DatasourceTableGitService extends AbstractGitService<
  DatasourceTableStoreModel,
  DatasourceLike,
  FilesDef<'metadata'> & FilesDef<'settings'> & FilesDef<'tests'>
> {
  constructor(
    protected readonly datasourceTableCfg: {
      folderType: DatasourceLike;
      git: GitService;
      gitQuery: GitQuery;
      parentFolders: GitParentFolders;
      errorHandlerService: ErrorHandlerService;
    },
  ) {
    super({
      gitQuery: datasourceTableCfg.gitQuery,
      git: datasourceTableCfg.git,
      name: `${datasourceTableCfg.folderType}-Table-Git`,
      basePath: getY42GitPath<DatasourceLike>(datasourceTableCfg.folderType),
      parentFolders: datasourceTableCfg.parentFolders,
      errorHandlerService: datasourceTableCfg.errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: DatasourceTableSettingsGitModel,
        },
        tests: {
          fileName: 'tests.json',
          model: DataTestGitModel,
        },
      },
    });
  }
}
